import router from '@/router'
import { i18n } from '@/plugins/i18n'
import $policy from '@/ability/policies'

export default {
    install(Vue, store) {
        Vue.prototype.$url = uri => {
            let current_url = window.location;

            if (current_url.host === '127.0.0.1' || current_url.host === 'localhost') {
                return current_url.protocol + '//'
                    + current_url.host + '/' + current_url.pathname.split('/')[1] + '/' + current_url.pathname.split('/')[2]
                    + uri
                ;
            }

            return current_url.protocol + '//' + current_url.host + '/' + uri;
        },

        Vue.prototype.goBack = () => {
            router.back()
        },

        Vue.prototype.$hasRole = role => {
            let current = store.getters['user/current']

            return current && current.role === role
        }

        Vue.prototype.$currentUser = () => {
            return store.getters['user/current']
        }

        Vue.prototype.$redirect = url => {
            window.location.replace(url)
        }

        Vue.prototype.$numberWithCommas = x => {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
        }

        Vue.prototype.$commas = x => {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
        }

        Vue.prototype.$dataTableFieldsMaker = fields => {
            const currentUser = store.getters['user/current']

            return fields.filter(field => {
                if (!field.policies) {
                    return true
                }

                return Object.keys(field.policies).some((policy) => {
                    return field.policies[policy].some(permission => $policy[policy](currentUser, {})[permission])
                })
            }).filter(field => {
                if (!field.roles) {
                    return true
                }

                return field.roles.some(
                    role => Vue.prototype.$hasRole(role) || role === 'any'
                )
            })
        }

        Vue.prototype.$isFaLocale = i18n.locale === 'fa'

        Vue.prototype.$autoDir = Vue.prototype.$isFaLocale ? 'rtl' : 'ltr'

        Vue.prototype.$strRandom = (length = 8) => {
            // Declare all characters
            // Just lowercase
            let chars = 'abcdefghijklmnopqrstuvwxyz0123456789'

            // Pick characers randomly
            let str = ''
            for (let i = 0; i < length; i++) {
                str += chars.charAt(Math.floor(Math.random() * chars.length))
            }

            return str
        }

        Vue.prototype.$policy = (policy, model = {}) => {
            const currentUser = store.getters['user/current']

            return $policy[policy](currentUser, model)
        }

        Vue.prototype.$deepClone = (obj) => {
            return JSON.parse(JSON.stringify(obj))
        }
    },
}